/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_InheritedInputs */

const cs_settings_venues_inherited = /** @type {(inputs: Settings_Venues_InheritedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převzato`)
};

const en_settings_venues_inherited = /** @type {(inputs: Settings_Venues_InheritedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inherited`)
};

/**
* | output |
* | --- |
* | "Inherited" |
*
* @param {Settings_Venues_InheritedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_inherited = /** @type {((inputs?: Settings_Venues_InheritedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_InheritedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_inherited(inputs)
	return cs_settings_venues_inherited(inputs)
});